import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-update-network-addition',
  templateUrl: './update-network-addition.component.html',
  styleUrls: ['./update-network-addition.component.scss']
})
export class UpdateNetworkAdditionComponent implements OnInit {
@Output() refreshTableData = new EventEmitter();
updateNetworkAdditionForm: FormGroup;
  loadPage: boolean;
  submitted=false;
  itemData: any;
  vpmnNetworkyList:any;
  selectedVPMNOrgId:any;
  

  constructor(private dialogRef: MatDialogRef<UpdateNetworkAdditionComponent>, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
    private spinnerService: Ng4LoadingSpinnerService, private endpointsService: EndpointsService, private backendApiService: BackendApiService) {
    this.spinnerService.show();
  }

  ngOnInit(): void {
    console.log("jjjj")
    this.itemData = this.data.rowData;
    console.log(this.itemData);
    this.updateBlacklistForm();
    this.getVPMNCountryDetails();
  }
  updateBlacklistForm() {
    this.updateNetworkAdditionForm = this.formBuilder.group({
      homecc: [this.itemData.homeCC, [Validators.minLength(1), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$")]],
      visitingcc: [this.itemData.vistingCC, [Validators.minLength(1), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$")]],
      homeCountry:[this.itemData.homeCountry],
      vpmnNetwork:[this.itemData.visitingNetwork,Validators.required],
      islive:[this.itemData.is_live,Validators.required],
     
    });
  }
  get f() {
    return this.updateNetworkAdditionForm.controls;
  }
  async getVPMNCountryDetails() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_COUNTRY_FOR_NETWORK_ADDITION 
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnNetworkyList = response   
      console.log("VPMN Country List:", this.vpmnNetworkyList);
      this.spinnerService.hide();
    });
  }
  onVPMNNetworkChange(selectedCountry: string) {
    const selectedItem = this.vpmnNetworkyList.find(item => item.visitingNetwork === selectedCountry);
    this.selectedVPMNOrgId = selectedItem ? selectedItem.vistingOrgId : "";
    console.log("Selected Org ID:", this.selectedVPMNOrgId);
  }
  onClose() {
    this.dialogRef.close();
  }
  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      return false;
    }
    return true;
  }
  onUpDate(){
    this.submitted=true;
    if (this.updateNetworkAdditionForm.invalid) {
      return;
    }
    console.log("aaaaaa")
  this.spinnerService.show();
  const apiUrl = this.endpointsService.URL_UPDATE_NETWORK_ADDITION +
      '&orgId=' + this.itemData.orgId.split(" ").join("")+
      '&vistingOrgId=' + this.itemData.vistingOrgId +
      '&vistingCC='+ this.updateNetworkAdditionForm.get('visitingcc').value +
      '&homeCC='+this.updateNetworkAdditionForm.get('homecc').value +
      '&is_live='+this.updateNetworkAdditionForm.get('islive').value
  
    this.backendApiService.callToApi(apiUrl).subscribe(res=>{
      console.log("response",res);
     if(res.status=='true'){
      alert("Updated Successfully");
      this.dialogRef.close();
      this.refreshTableData.emit();
     }else{
      alert('Not Updated');
      this.dialogRef.close();
     
      return;
     }
    })
  }
}
